<svelte:head>
  
<link rel="stylesheet" type="text/css" href="./deps/bootstrap-3.3.1/css/bootstrap.css" />
<link rel="stylesheet" type="text/css" href="./deps/bootstrap-3.3.1/css/bootstrap-theme.css" />
  
</svelte:head>

<script>

	import { onMount, setContext, getContext  } from 'svelte';

	import { account_service       , account_service_context_key        } from './_services/account.js';
	import { loggedIn                                                   } from './_services/accountsession.js';
	import { cookiejar_service     , cookiejar_service_context_key      } from './_services/cookiejar.js';

	import Router     from 'svelte-spa-router'

	import NotFound	from './NotFound.svelte';
	import Navigation	from './Navigation.svelte';
	import Footer		from './Footer.svelte';

	import Home			from './Home.svelte';
	import Gallery		from './Gallery.svelte';
	import About		from './About.svelte';
	import Login		from './Login.svelte';
  	import AppList		from './AppList.svelte';
  	
	//import Author	from './routes/Author.svelte';
	//import Book		from './routes/Book.svelte';


	const routes = {
	    // Exact path
	    '/': Home,
	    '/home': Home,
	    '/gallery': Gallery,
	    '/about': About,
	    '/login': Login,
       '/applist': AppList,
	    '/applist/:app_id?/*': AppList,
	
	    // Using named parameters, with last being optional
	//    '/author/:first/:last?': Author,
	 
	    // Wildcard parameter
	//    '/book/*': Book,
	 
	    // Catch-all
	    // This is optional, but if present it must be the last
	    '*': NotFound,
	}

	onMount(async () => {

	});


	function handleSessionEvent(event) {
		console.log('function handleSessionEvent(event) -- ' + event.detail.loggedIn);
	}

</script>

<style>

#content {
  visibility: visible;
  display: block;
  height: 100%;
  width: 100%;
  top: 40px;
  left: 0px;
  right: 0px;
  padding: 0px;
  margin: 0px;
}

</style>

<main style="position:relative; width:100%; height:100%; padding: 0px; margin: 0px;">

<Navigation 
	on:sessionEvent={handleSessionEvent}
	/>

<div id="content">
	<br/>
	<Router {routes} />
</div>

<Footer 
	/>

	
</main>